module.exports = "https://static.wmbcdn.com/uniweb/images/3fc89967122df52a5775fc9ef2c6f00c.svg";